import { ref } from '@vue/composition-api'
// import { debounce } from 'lodash'
import { errorNotification, successNotification } from '@/utils/toast-notifications'

export default function useCreate(props, ctx) {
  const fetchingBusinessTypes = ref(false)
  const createBusinessRef = ref(null)
  const businessData = ref({
    name: null,
    businessTypes: null,
    email: null,
    phoneNumber: null,
    password: null,
    businessName: {
      en: '',
      ar: '',
    },
    businessEmail: '',
    businessPhoneNumber: '',
  })
  const businessTypes = ref([])
  const getBusinessTypes = async () => {
    try {
      fetchingBusinessTypes.value = true
      const res = await ctx.root.$store.dispatch('business/getBusinessTypes', {
        active: true,
      })
      const { data } = res.data.data
      businessTypes.value = data
      businessData.value.businessTypes = data[0].id
    } finally {
      fetchingBusinessTypes.value = false
    }
  }
  getBusinessTypes()

  const submitting = ref(false)
  const isOtpStage = ref(false)
  const submit = async () => {
    try {
      const validationRes = await createBusinessRef.value.validate()
      if (!validationRes) return
      submitting.value = true
      await ctx.root.$store.dispatch('business/createBusiness', {
        ...businessData.value,
        businessTypes: [businessData.value.businessTypes],
      })
      successNotification(`Check OTP sent to ${businessData.value.email}`)
      isOtpStage.value = true
    } catch (error) {
      console.log(error.response)
      const err = error.response?.data?.error?.errors[0]
      let errMsg = ''
      if (typeof err === 'string') errMsg = err
      else errMsg = err.message
      errorNotification(errMsg || 'Something went wrong')
      console.log(error)
    } finally {
      submitting.value = false
    }
  }

  const activatedBusinessId = ref(undefined)
  const activatedBusinessExternalId = ref(undefined)
  const submittedBusinessType = ref('')
  const fetchBusinessByEmail = async () => {
    const result = await ctx.root.$store.dispatch('business/getBusinessByEmail', {
      // email: 'adham.mlatyali+99@alsafeerit.com',
      email: businessData.value.businessEmail,
    })
    const businessId = result.data.data.data.id
    const businessType = result.data.data.data.businessTypes[0].logicalId
    const { externalId } = result.data.data.data
    submittedBusinessType.value = businessType
    activatedBusinessId.value = businessId
    activatedBusinessExternalId.value = externalId
  }
  const otpCode = ref('')
  const submittingCode = ref(false)
  const businessVerified = ref(false)
  const confirmBusiness = async () => {
    try {
      submittingCode.value = true
      await ctx.root.$store.dispatch('business/confirmBusiness', {
        email: businessData.value.email,
        code: otpCode.value,
      })
      businessVerified.value = true
      await fetchBusinessByEmail()
      // ctx.emit('next', activatedBusinessId.value)
      successNotification('Business verified successfully')
    } catch (error) {
      errorNotification('Wrong OTP code')
    } finally {
      submittingCode.value = false
    }
  }

  const forceConfirmBusiness = async () => {
    try {
      submittingCode.value = true
      await ctx.root.$store.dispatch('business/forceConfirmBusiness', {
        email: businessData.value.email,
      })
      businessVerified.value = true
      await fetchBusinessByEmail()
      // ctx.emit('next', activatedBusinessId.value)
      successNotification('Business verified successfully')
    } catch (error) {
      errorNotification('Wrong OTP code')
    } finally {
      submittingCode.value = false
    }
  }

  const gotoProfile = () => {
    // eslint-disable-next-line no-alert
    const res = prompt('Skip business registration and go to profile?', 'Yes, go to profile')
    if (res) {
      if (submittedBusinessType.value === 'restaurant') {
        ctx.root.$router.push(`/businesses/food/details/${activatedBusinessId.value}?externalId=${activatedBusinessExternalId.value}`)
      }
      ctx.root.$router.push(`/businesses/ride-hailing/details/${activatedBusinessId.value}?externalId=${activatedBusinessExternalId.value}`)
    }
    return ''
  }
  return {
    submit,
    submitting,
    createBusinessRef,
    gotoProfile,
    forceConfirmBusiness,
    businessData,
    isOtpStage,
    submittingCode,
    fetchingBusinessTypes,
    businessVerified,
    confirmBusiness,
    businessTypes,
    otpCode,
  }
}
